import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import { 
    FaThLarge, 
    FaCalendarPlus,
    FaHistory,
    FaUserCircle,
    FaFileContract,
    FaLock,
    FaSignOutAlt,
    FaBell,
    FaTimes,
    FaCashRegister
} from 'react-icons/fa';
import './Sidebar.css';

const Sidebar = ({ isOpen, onClose }) => {
    const location = useLocation();
    const [unreadCount, setUnreadCount] = useState(0);
    const [profileData, setProfileData] = useState(null);
    const baseUrl = "https://api.burrayhr.com";

    useEffect(() => {
        fetchLeaves();
        fetchProfile();
        const interval = setInterval(fetchLeaves, 30000);
        return () => clearInterval(interval);
    }, []);

    const fetchProfile = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`${baseUrl}/api/profile/`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            console.log(response.data);
            setProfileData(response.data);
        } catch (error) {
            console.error('Error fetching profile:', error);
        }
    };
    
    
    const fetchLeaves = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`${baseUrl}/api/leaves/`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            
            const unreadLeaves = response.data.filter(
                leave => !leave.is_read && leave.response_message
            );
            setUnreadCount(unreadLeaves.length);
        } catch (error) {
            console.error('Error fetching leaves:', error);
        }
    };

    const handleMenuClick = (item) => {
        if (item.onClick) {
            item.onClick();
        }
        if (item.path === '/employee/leave-history') {
            setUnreadCount(0);
        }
        // Close sidebar on mobile after clicking a menu item
        if (window.innerWidth <= 768) {
            onClose();
        }
    };

    const menuItems = [
        {
            path: "/employee/dashboard",
            name: "Dashboard",
            icon: <FaThLarge />
        },
        {
            path: "/employee/apply-leave",
            name: "Apply For Leave",
            icon: <FaCalendarPlus />
        },
        {
            path: "/employee/leave-history",
            name: "Leave History",
            icon: <FaHistory />,
        },
        // {
        //     path: "/employee/loan-request",
        //     name: "Apply For Loan",
        //     icon: <FaCashRegister />
        // },

        // {
        //     path: "/employee/loan-history",
        //     name: "Loan History",
        //     icon: <FaHistory />,
        // },
        {
            path: "/employee/profile",
            name: "Profile",
            icon: <FaUserCircle />
        },
        {
            path: "/employee/notices",
            name: "Notices",
            icon: <FaBell />
        },
        {
            path: "/employee/change-password",
            name: "Change Password",
            icon: <FaLock />
        },
        {
            path: "/",
            name: "Logout",
            icon: <FaSignOutAlt />,
            onClick: () => {
                localStorage.clear();
            }
        }
    ];

    return (
        <>
            <div className={`mobile-overlay${isOpen ? ' show' : ''}`} onClick={onClose}></div>
            <div className={`sidebar${isOpen ? ' open' : ''}`}>
                <button className="mobile-close-btn" onClick={onClose}>
                    <FaTimes />
                </button>
                <div className="sidebar-header">
                    <img style={{width: '70px', height: '70px', borderRadius: '10%'}} src={profileData?.company_data?.logo} alt="Burray Logo" className="sidebar-logo" />
                </div>
                <div className="sidebar-menu">
                    {menuItems.map(item => (
                        <Link 
                            to={item.path} 
                            key={item.name} 
                            className={`menu-item ${location.pathname === item.path ? 'active' : ''}`}
                            onClick={() => handleMenuClick(item)}
                        >
                            <div className="menu-item-content">
                                <span className="icon">{item.icon}</span>
                                <span className="menu-text">{item.name}</span>
                            </div>
                            {item.notification > 0 && (
                                <span className="notification-badge">{item.notification}</span>
                            )}
                        </Link>
                    ))}
                </div>
            </div>
        </>
    );
};

export default Sidebar;
